var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKimaCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#010101"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFA",
    d: "M16.1,23.7c0,3.5,0,7,0,10.5c0,0.5-0.1,1.1,0.7,1.1c1.3,0,2.7,0,4,0c0.2,0,0.6-0.4,0.6-0.6     c0.1-0.8,0-1.7,0-2.5c0-1.2,0-2.4,0-3.5c1,0.3,1.9,0.6,2.8,0.8c1.7,0.2,2.7,1.2,2.9,3c0,0.4,0.1,0.8,0.2,1.2     c0.4,1.4,1.3,2.1,2.7,2.3c1.3,0.2,2.6-0.5,3.3-1.6c0.7-1.2,0.5-2.4-0.3-3.5c-0.7-1.1-1.8-1.3-3-1.5c-1.6-0.2-2.7-1.4-2.8-2.9     c-0.1-1.4,1-2.8,2.6-3.1c0.4-0.1,0.8-0.1,1.2-0.2c1.6-0.3,2.7-1.7,2.7-3.4c0-1.6-1.3-3-2.9-3.1c-2-0.2-3.4,1.1-3.6,3.2     c-0.1,1.7-1,2.8-2.4,3c-1.1,0.2-2.2,0.5-3.4,0.8c0-0.1,0-0.5,0-0.8c0-3.8,0-7.6,0.1-11.4c0-1-0.3-1.3-1.3-1.2     c-1,0.1-2.1,0.1-3.1,0c-0.9-0.1-1.2,0.3-1.1,1.1C16.2,13.4,16.1,18.5,16.1,23.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKimaCircleIcon);
export default __webpack_public_path__ + "static/media/KIMACircleIcon.38149ba47c8629db3bd91de043b8a280.svg";
export { ForwardRef as ReactComponent };